import React from "react";
import { FormFeedback, Input, Label } from "reactstrap";

const SelectCustom = ({lblInput, inputName, inputType, inputPlaceholder, validation, disabled, data=[]}) => {
    const isInvalid = validation.touched[inputName] && validation.errors[inputName];
    
    return (
        <React.Fragment>
            <div className="mb-3">
                <Label className="form-label">{lblInput}</Label>
                <select 
                    disabled={disabled} 
                    className={`form-control ${isInvalid ? 'is-invalid' : ''}`}
                    name={inputName}
                    type={inputType}
                    placeholder={inputPlaceholder}
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values[inputName] || ""}
                >
                    <option value={''}>Elige...</option>
                    {data?.length>0 && data?.map((item, key) => {
                        return <option key={key} value={item?.id}>{item?.name}</option>
                    })}
                </select>
                {validation.touched[inputName] &&
                    validation.errors[inputName] ? (
                    <FormFeedback type="invalid">
                        {validation.errors[inputName]}
                    </FormFeedback>
                ) : null}
            </div>
        </React.Fragment>
    );
};

export default SelectCustom;